<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h1>
      Thank you!
    </h1>
    <p>
      Your Site Equipment Change request has been submitted. You will be notified when this change request
      has been processed.
    </p>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Order Summary</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody v-if="smbTotal != 0">
        <tr>
          <td>Site Balance</td>
          <td>${{smbTotal}}</td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td>Site Equipment Change</td>
          <td>${{erTotal}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{paymentTotal}}</td>
        </tr>
      </tbody>
    </table>
    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system. After approval of your permit application by the department, it will be emailed to the address you
      provided with your application.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-12">Email: certificateofoperations@cookcountyil.gov</dt>
    </dl>
  </div>
</template>
<script>
import { submitEquipmentChangeRequest, getChangeFees, confirmTransaction } from '@/js/FormFunctions';

export default {
  name: 'AirThankYou',
  props: ['erid', 'gatewayKey', 'requestId'],
  data() {
    return {
      siteNumber: '',
      isValidNum: false,
      fetchingData: false,
      erroMessage: '',
      paymentTotal: 0,
      smbTotal: 0,
      erTotal: 0,
      confirmationNumber: null,
    };
  },
  beforeMount() {
    this.fetchingData = true;

    this.confirmationNumber = this.$route.query.confirmationNumber;

    confirmTransaction(this.gatewayKey, this.confirmationNumber, this.requestId)
      .then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].type == 'ER') {
            this.erTotal = res[i].amount;
          } else {
            this.smbTotal = res[i].amount;
          }
        }
        this.paymentTotal = this.smbTotal + this.erTotal;
        this.fetchingData = false;
      })
      .catch((error) => {
        this.fetchingData = false;
      });
    /*
      getChangeFees(this.erid)
        .then((res) => {
          this.paymentTotal = res.equipmentChangeFee.fee
        })
        */
  },
};

</script>
